<template>
    <div v-if="!isMobileNav" class="look_userLoginHander  look_metaNavRightContent__item  look_metaNavRightContent__item--2">
        <ul v-if="!isLoggedIn" class="look_metaNavLogin">
            <li class="look_headerLogin">
                <a data-toggle="modal"
                   :href="isLogin ? 'javascript:void(0)' : '#login'"
                   :data-toggle="isLogin ? false : 'modal'"
                   @click="createLoginModal(); unmarkInputFields();"
                   :aria-label="$translate('Ceres::Template.login')">
                    <b>{{ $translate("HoferAntikschmuck::Template.headerLogin") }}</b>
                </a>
            </li>
            <li class="look_headerRegister">
                <a data-toggle="modal"
                   :href="isRegister ? 'javascript:void(0)' : '#registration'"
                   :data-toggle="isRegister ? false : 'modal'"
                   @click="createRegisterModal(); unmarkInputFields();"
                   :aria-label="$translate('Ceres::Template.loginRegister')">
                    {{ $translate("HoferAntikschmuck::Template.headerRegister") }}
                </a>
            </li>
        </ul>
        <ul v-if="isLoggedIn" class="look_metaNavLogin isLoggedIn d-flex">
            <li class="look_metaNavLogin__li-1">
                <a :href="$ceres.urls.myAccount">
                    <b>{{ $translate("HoferAntikschmuck::Template.headerMyAccount") }}</b>
                </a>
            </li>
			<li class="look_metaNavLogin__li-2">
				<a href="#" v-logout>
					<b>{{ $translate("HoferAntikschmuck::Template.headerLogout") }}</b>
				</a>
			</li>
        </ul>
    </div>
	<li v-else>


		<a v-if="!isLoggedIn" data-toggle="modal"
		   :href="isLogin ? 'javascript:void(0)' : '#login'"
		   :data-toggle="isLogin ? false : 'modal'"
		   @click="createLoginModal(); unmarkInputFields();"
		   :aria-label="$translate('Ceres::Template.login')">
			<svg stroke="currentColor">
				<use xlink:href="#user" />
			</svg>

			<span>
				{{ $translate("HoferAntikschmuck::Template.headerLogin") }}
			</span>
		</a>

		<a v-if="isLoggedIn" :href="$ceres.urls.myAccount">
			<svg stroke="currentColor">
				<use xlink:href="#user" />
			</svg>

			<span>
				{{ $translate("HoferAntikschmuck::Template.headerMyAccount") }}
			</span>
		</a>

		<a class="logout" v-if="isLoggedIn" href="#" v-logout>
			{{ $translate("HoferAntikschmuck::Template.headerLogout") }}
		</a>
	</li>
</template>

<script>
import ValidationService from "ceres/app/services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        },
        isMobileNav: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
			if(this.isMobileNav){
				this.$store.commit("setIsMobileNavigationOpen", false);
			}
            this.loadComponent("login-modal");
			this.loadComponent("register-modal");

		},

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
